"use client";

import React from "react";
import dynamic from "next/dynamic";
import { useAction } from "next-safe-action/hooks";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import HomeSection from "@/components/home-section";
import CategorySliderBar from "@/components/category-slider-bar";
const CategoryContent = dynamic(() => import("./category-content"), {
  ssr: false,
});

import { fetchExamPreferenceCategories } from "@/fetchers/store";
import useMediaQuery from "@/hooks/use-media-query";

function PopularOnlineCourse() {
  const isMobile = useMediaQuery("(max-width:480px)");

  const [goalId, setGoalId] = React.useState(null);
  const [languageId, setLanguageId] = React.useState(0);

  const {
    hasSucceeded,
    result: { data: categories } = {},
    execute: fetchCategories,
  } = useAction(fetchExamPreferenceCategories);

  // Fetch exam preference categories on mount
  React.useEffect(() => {
    if (!hasSucceeded) fetchCategories();
  }, [hasSucceeded, fetchCategories]);

  React.useEffect(() => {
    if (isMobile && categories?.length && goalId === null) {
      setGoalId(categories[0].id);
    }
  }, [isMobile, categories, goalId]);

  const handleOnChangeGoal = React.useCallback((selectedGoalId) => {
    setGoalId(selectedGoalId);
    setLanguageId(0);
  }, []);

  const handleLanguageChange = React.useCallback((languageId) => {
    setLanguageId(languageId);
  }, []);

  if (isMobile) {
    return (
      <HomeSection
        id="popular-online-courses"
        title="Study Online"
        subtitle={
          <>
            <span>Explore our most</span>
            <span className="text-primary">Popular Online Courses</span>
          </>
        }
      >
        <Accordion
          collapsible
          value={goalId}
          onValueChange={(categoryId) => {
            handleOnChangeGoal(categoryId);
          }}
        >
          {categories?.map((category) => (
            <AccordionItem
              key={category.id}
              value={category.id}
              className="border-0"
            >
              <AccordionTrigger className="border-b border-grayscale-input font-semibold">
                {category.title}
              </AccordionTrigger>
              <AccordionContent className="pt-6">
                <CategoryContent
                  key={goalId}
                  goalId={goalId}
                  languageId={languageId}
                  onLanguageChange={handleLanguageChange}
                />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </HomeSection>
    );
  }

  return (
    <HomeSection
      id="popular-online-courses"
      title="Study Online"
      subtitle={
        <>
          <span>Explore our most</span>
          <span className="text-primary">Popular Online Courses</span>
        </>
      }
    >
      <CategorySliderBar
        categories={categories}
        onChange={handleOnChangeGoal}
      />
      <CategoryContent
        key={goalId}
        goalId={goalId}
        languageId={languageId}
        onLanguageChange={handleLanguageChange}
      />
    </HomeSection>
  );
}

export default PopularOnlineCourse;
